var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "vs-sidebar-group",
      class: [
        { "vs-sidebar-group-open": _vm.openItems },
        { "vs-sidebar-group-active": _vm.open },
        { "disabled-item pointer-events-none": _vm.group.isDisabled },
      ],
      on: { mouseover: _vm.mouseover, mouseout: _vm.mouseout },
    },
    [
      _c(
        "div",
        { staticClass: "group-header w-full", on: { click: _vm.clickGroup } },
        [
          _c(
            "span",
            { staticClass: "flex items-center w-full" },
            [
              _vm.group.icon || this.groupIndex > Math.floor(this.groupIndex)
                ? _c("feather-icon", {
                    attrs: {
                      icon: _vm.group.icon || "CircleIcon",
                      svgClasses: { "w-3 h-3": this.groupIndex % 1 != 0 },
                    },
                  })
                : _vm._e(),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.sidebarItemsMin,
                      expression: "!sidebarItemsMin",
                    },
                  ],
                  staticClass: "truncate mr-3 select-none",
                },
                [_vm._v(_vm._s(_vm.$t(_vm.group.i18n) || _vm.group.name))]
              ),
              _vm.group.tag && !_vm.sidebarItemsMin
                ? _c(
                    "vs-chip",
                    {
                      staticClass: "ml-auto mr-4",
                      attrs: { color: _vm.group.tagColor },
                    },
                    [_vm._v(_vm._s(_vm.group.tag))]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c("feather-icon", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.sidebarItemsMin,
                expression: "!sidebarItemsMin",
              },
            ],
            class: [{ rotate90: _vm.openItems }, "feather-grp-header-arrow"],
            attrs: { icon: "ChevronRightIcon", "svg-classes": "w-4 h-4" },
          }),
          _c("span", { staticClass: "vs-sidebar--tooltip" }, [
            _vm._v(_vm._s(_vm.$t(_vm.group.i18n) || _vm.group.name)),
          ]),
        ],
        1
      ),
      _c(
        "ul",
        {
          ref: "items",
          staticClass: "vs-sidebar-group-items",
          style: _vm.styleItems,
        },
        _vm._l(_vm.group.submenu, function (groupItem, index) {
          return _c(
            "li",
            { key: index },
            [
              groupItem.submenu
                ? _c("vx-sidebar-group", {
                    attrs: {
                      group: groupItem,
                      groupIndex: Number(_vm.groupIndex + "." + index),
                      open: _vm.isGroupActive(groupItem),
                      openHover: _vm.openHover,
                    },
                  })
                : _c(
                    "vx-sidebar-item",
                    {
                      attrs: {
                        index: _vm.groupIndex + "." + index,
                        to: groupItem.url,
                        icon: _vm.itemIcon(_vm.groupIndex + "." + index),
                        "icon-small": "",
                        target: groupItem.target,
                      },
                    },
                    [
                      _c("span", { staticClass: "truncate" }, [
                        _vm._v(
                          _vm._s(_vm.$t(groupItem.i18n) || groupItem.name)
                        ),
                      ]),
                      groupItem.tag
                        ? _c(
                            "vs-chip",
                            {
                              staticClass: "ml-auto",
                              attrs: { color: groupItem.tagColor },
                            },
                            [_vm._v(_vm._s(groupItem.tag))]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
            ],
            1
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }